import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import TargetCard from './TargetCard';
import TargetHand from './TargetHand';
import data from './data';
import './Target.scss';

const Target: React.FC = () => {
  return (
    <div className="target centered" id="target">
      <div className="target__container container">
        <div className="target__lightning">
          <picture>
            <source srcSet={require('images/target/lightning.webp')} type="image/webp" />
            <img src={require('images/target/lightning.png')} alt="lightning" />
          </picture>
        </div>
        <ContentFrame className="target__frame" title="Our Mission">
          <div className="target__content">
            <SectionTitle className="target__title">
              <span>Our Mission</span>
            </SectionTitle>
            <TargetHand />
            <div className="target__list">
              {data.map((col, colId) => (
                <div className="target__list-col" key={colId}>
                  {col.map((item) => (
                    <TargetCard {...item} key={item.id} />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </ContentFrame>
      </div>
    </div>
  );
};

export default Target;
